export default __webpack_public_path__ + "static/media/swap.a8c424fb.svg";